import Send from '@/config/api/index'

const registryPath = "/v1/registry"

function registryApi(api, params, config) {
    return Send.post(registryPath + api, params, config)
}

export default {
    getImageTags(imageNm, config) {
        return registryApi('/image/tags', { imageNm }, config)
    }
}